// stores/loadingStore.ts
import { defineStore } from 'pinia';

export const useLoadingStore = defineStore('loading', {
  state: () => ({
    isLoading: false
  }),

  getters: {
    getLoadingState: (state) => state.isLoading
  },
  actions: {
    setLoading(isLoading: boolean) {
      this.isLoading = isLoading;
    }
  }
});
